import React from 'react';
import { styled, Button } from '@teko/ui';
import { space } from 'styled-system';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = styled.div(space, `
    white-space: nowrap;
    display: flex;
  `);
const BreadcrumbBlock = styled.div`
  height: 32px;
  width: fit-content;
  align-items: center;
  display: flex;
  justify-content: center;
  white-space: nowrap;
`;
const StyledButton = styled(Button)(({ isDisable, color, outline }) => `
  padding: ${outline ? "8px" : "4px"};
  color: ${isDisable ? "rgba(0,0,0,.38)" : color};
  text-decoration: none;
  background-color: #FFF;
  pointer-events: ${isDisable ? "none" : "auto"};
  border: ${outline ? "1px solid #e0e0e0" : "none"};
  border-radius: 9999px;
  --button-icon-color: ${color};
  &:hover {
    color: ${color};
    background-color: #FFF;
    --button-icon-color: ${color};
  }
   `);
const Divider = styled.span`
  margin: 0 8px;
  color: #9b9b9b;
  font-size: inherit;
`;
const Breadcrumb = (_a) => {
  var _b = _a, {
    items,
    divider,
    color = "#848788",
    outline
  } = _b, props = __objRest(_b, [
    "items",
    "divider",
    "color",
    "outline"
  ]);
  return /* @__PURE__ */ React.createElement(Wrapper, __spreadValues({}, props), items.map((breadcrumb, index) => {
    return /* @__PURE__ */ React.createElement(BreadcrumbBlock, {
      key: index
    }, /* @__PURE__ */ React.createElement(StyledButton, {
      icon: breadcrumb.icon,
      link: true,
      outline,
      color,
      isDisable: breadcrumb.disabled,
      href: breadcrumb.href,
      tag: "a"
    }, breadcrumb.text), index !== items.length - 1 && /* @__PURE__ */ React.createElement(Divider, null, divider));
  }));
};

export { Breadcrumb };
